module.exports = __webpack_public_path__ + "img/logo_main.c31317ad.svg";